import EditWorkoutProfile from "@/components/WorkoutProfiles/EditWorkoutProfile/EditWorkoutProfile";
import { useWorkoutProfilesContext } from "@/hooks/useWorkoutProfilesContext";
import ActionMenu from "@/components/WorkoutProfiles/EditWorkoutProfile/ActionMenu";
import { useParams } from "react-router";
import { useMemo } from "react";

const ProfileDetailsPage = () => {
  const params = useParams();
  const { getWorkoutProfile } = useWorkoutProfilesContext();
  const profileId = params.profileId || "";
  const profile = useMemo(() => getWorkoutProfile(profileId), [getWorkoutProfile, profileId]);

  return (
    <EditWorkoutProfile
      profile={profile}
      headerAction={<ActionMenu profileId={profileId} permanent={profile?.permanent} />}
    />
  );
};

export default ProfileDetailsPage;
